<template>
<v-container fluid grid-list-lg class="ma-0 pa-0">
<v-layout row wrap>
  <v-flex xs12 class="mb-2"><h1>Shipments</h1></v-flex>
  
  <v-flex xs12 id="test">
  <v-hover 
    v-for="(draft, i) in draftItems" 
    :key="i"
  >
  <v-card 
    class="mb-3 pointer"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 10 : 2}`"
  >
    <v-toolbar @click="showDraftShipment(draft)" :class="{'primary white--text' : !isDark}">
        <v-toolbar-title>{{draft.id}}</v-toolbar-title>
        <v-spacer></v-spacer>
        {{draft.updated_at | toTimestamp}}
    </v-toolbar>
    <v-card-text @click="showDraftShipment(draft)">
        <v-card flat>
        <v-container grid-list-sm fluid class="pa-0 ml-0 mt-0">
        <v-layout row wrap>
            <v-flex
            v-for="(item, i) in draft.line_items"
            :key="i"
            xs2
            d-flex
            >
                <v-card tile class="d-flex elevation-2">
                <v-layout column>
                    <v-flex xs12>
                        <v-img v-if="item.image" :src="item.image"/>
                        <div v-else class="primary" style="width:175.83px;height:175.83px;"></div>
                    </v-flex>
                    <v-flex xs12 class="pt-0 pb-3 pl-0 text-xs-center">
                        {{item.sku}}<br><b>{{item.name}}</b>
                    </v-flex>
                </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
        </v-container>
        </v-card>
    </v-card-text>
  </v-card>
  </v-hover>
  </v-flex>

<v-dialog
    v-model="ui.shipment"
    persistent
    id="draft-shipment"
>
    <v-card v-if="shipment">
        <v-toolbar :class="{'primary white--text' : !isDark}">
            <v-toolbar-title>{{shipment.id}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="ui.shipment = false" :class="{'white--text' : !isDark}">
                <v-icon small>close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-card-text>
            <v-layout row wrap>
                <v-flex xs12 sm8 class="pr-3">
                    <h3 class="mt-0 mb-0">Draft Items</h3>
                    <v-data-table
                        :headers="line_item_headers"
                        :items="shipment.line_items"
                        hide-actions
                    >
                        <template slot="items" slot-scope="props">
                            <tr style="height:90px;" :class="{'packed': props.item.quantity === 0}">
                            <td>
                                <v-img v-if="props.item.image" :src="props.item.image" width="80"/>
                                <div v-else class="primary" style="width:80px;height:80px;"></div>
                            </td>
                            <td>{{props.item.sku}}<br><b>{{ props.item.name }}</b></td>
                            <td>{{getVariantInventory(props.item.product, props.item.sku)}}</td>
                            <td>{{ props.item.quantity }}</td>
                            <td><v-btn @click="addToPacked(props.item)" :disabled="props.item.quantity === 0">pack</v-btn></td>
                            </tr>
                        </template>
                    </v-data-table>

                    <h3 class="mt-4 mb-0">Packed</h3>
                    <div v-if="packed.length === 0">Nothing has been packed yet.</div>
                    <v-data-table
                        v-if="packed.length > 0"
                        :headers="packed_item_headers"
                        :items="packed"
                        hide-actions
                        class="mt-0"
                    >
                        <template slot="items" slot-scope="props">
                            <tr style="height:90px;">
                            <td>
                                <v-img v-if="props.item.image" :src="props.item.image" width="80"/>
                                <div v-else class="primary" style="width:80px;height:80px;"></div>
                            </td>
                            <td>{{props.item.sku}}<br><b>{{ props.item.name }}</b></td>
                            <td>{{ props.item.quantity }}</td>
                            <td><v-btn @click="removeFromPacked(props.item)">unpack</v-btn></td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>

                <v-flex xs12 sm4>
                    <!--<v-btn :disabled="packed.length === 0" block large color="primary" class="mt-1 mb-3 elevation-8">Print Packing Slip & Labels</v-btn>-->
                    <v-overflow-btn
                        v-if="!ui.printing"
                        class="pt-0"
                        v-model="ui.print_option"
                        :disabled="!isReadyToBeCompleted"
                        :items="print_options"
                        segmented
                        target="#draft-shipment"
                        :background-color="isReadyToBeCompleted ? 'primary' : 'default'"
                        :dark="isReadyToBeCompleted"
                        color="#FFF"
                    ></v-overflow-btn>

                    <v-btn @click="reprint" v-if="canBeReprinted" :loading="ui.printing" block class="mt-1">Reprint</v-btn>

                    <div v-if="ui.print_error" class="text-xs-center mb-3">
                        There was an error with the print job, please try reprinting.
                    </div>

                    <div v-if="ui.printing" class="text-xs-center mb-3">
                        <h2>Printing</h2>
                        <v-progress-circular
                        indeterminate
                        :color="isDark ? '#FFF' : 'primary'"
                        ></v-progress-circular>
                    </div>
                    <v-flex xs12>
                        <v-container grid-list-md fluid class="pa-0 ml-0 mt-0">
                        <v-layout row wrap>
                            <v-flex xs4 v-if="shipment.draft_packing_slip" class="mb-3">
                                <v-btn small block :href="shipment.draft_packing_slip" target="_blank">Packing Slip</v-btn>
                            </v-flex>
                            <v-flex xs4 v-if="shipment.draft_shipment_shipping_label" class="mb-3">
                                <v-btn small block :href="shipment.draft_shipment_shipping_label.label_download.href" target="_blank">Shipping Label</v-btn>
                            </v-flex>
                            <v-flex xs4 v-if="shipment.draft_return_shipping_label" class="mb-3">
                                <v-btn small block :href="shipment.draft_return_shipping_label.label_download.href" target="_blank">Return Label</v-btn>
                            </v-flex>
                        </v-layout>
                        </v-container>
                    </v-flex>
                    <v-divider class="mb-3"></v-divider>
                    <h3 class="mb-3">Shipping To</h3>
                    <v-layout row wrap>
                        <v-flex xs12 sm6><v-text-field label="First Name" :value="shipment.shipping_address.first_name" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm6><v-text-field label="Last Name" :value="shipment.shipping_address.last_name" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm12><v-text-field label="Address" :value="shipment.shipping_address.address1" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm12 v-if="shipment.shipping_address.address2 !== ''"><v-text-field label="Address 2" :value="shipment.shipping_address.address2" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm6><v-text-field label="City" :value="shipment.shipping_address.city" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm3><v-text-field label="State" :value="shipment.shipping_address.province_code" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm3><v-text-field label="Zip" :value="shipment.shipping_address.zip" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm12><v-text-field  height="10" label="Country" :value="shipment.shipping_address.country" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm12 v-if="shipment.shipping_address.phone"><v-text-field label="Phone" :value="shipment.shipping_address.phone" box readonly hide-details></v-text-field></v-flex>
                    </v-layout>

                    <h3 class="mt-3 mb-3">Package</h3>
                    <v-layout row wrap>
                    <v-flex xs12>
                    <v-select
                    :items="shipment_settings.shipment_boxes"
                    v-model="shipment_box"
                    item-text="name"
                    return-object
                    box
                    label="Shipping Box"
                    hide-details
                    class="mb-0 pb-0"
                    >
                    </v-select>
                    </v-flex>
                    <v-flex xs12 sm3><v-text-field label="Height" v-model="shipment_box.height" suffix="in" box hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm3><v-text-field label="Width"  v-model="shipment_box.width" suffix="in" box hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm3><v-text-field label="Length" v-model="shipment_box.length" suffix="in" box hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm3><v-text-field label="Weight" v-model="calculatedPackageWeight" suffix="oz" box read-only hide-details></v-text-field></v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card-text>

        <v-card-actions class="pb-0 pl-0 pr-0">
            <v-btn :disabled="!isReadyToBeCompleted" :loading="ui.completing" @click="completeShipment" block large color="success" class="elevation-0">completed</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>

</v-layout>
</v-container>
</template>

<script>
import { db, functions } from '@/services/firebase.js'
import { isUndefined, clone } from 'lodash'
import moment from 'moment'

export default {
    data () {
        return {
            ui: {
                loading: true,
                shipment: false,
                packing: false,
                printing: false,
                print_error: false,
                completing: false,
                print_option: { text: 'Generate & Print Packing Slip/Labels', callback: () => this.printPackingSlipAndLabels() },
            },
            drafts: [],
            products: [],
            shipment_settings: null,
            shipment_box: null,
            shipment: null,
            line_item_headers: [
                { text: '', value: 'image', sortable: false },
                { text: 'Item', align: 'left', value: 'title', sortable: false },
                { text: 'On Hand', value: 'inventory', width: 20, sortable: false },
                { text: 'Required', value: 'quantity', width: 20, sortable: false },
                { text: '', value: 'pack', sortable: false },
            ],
            packed_item_headers: [
                { text: '', value: 'image', sortable: false },
                { text: 'Item', align: 'left', value: 'title', sortable: false },
                { text: 'Quantity', value: 'quantity', width: 20, sortable: false },
                { text: '', value: 'pack', sortable: false },
            ],
            shipping_boxes: ['USPS First Class', 'USPS Priority'],
            packed: [],
            print_options: [
                { text: 'Generate & Print Packing Slip/Labels', callback: () => this.printPackingSlipAndLabels() },
                { text: 'Generate & Print Packing Slip', callback: () => this.printPackingSlip() },
                { text: 'Generate & Print Labels', callback: () => this.printLabels() }
            ]
        }
    },
    filters: {
        toDate: function(str){
            return moment(str).format('MM/DD/YY')
        },
        toTimestamp: function(str){
            return moment(str).format('MM/DD/YY hh:mm:ss A')
        },
        toOunces: function(grams) {
            return Math.ceil(grams * 0.0352739619)
        }
    },
    computed: {
        isAdmin () {
            return this.$store.getters.isAdmin !== null && this.$store.getters.isAdmin !== undefined
        },
        isManager () {
            return this.$store.getters.isManager !== null && this.$store.getters.isManager !== undefined
        },
        isDark: function () {
            return this.$vuetify.dark
        },
        draftItems: function () {
            var self = this

            var drafts = []

            if (self.drafts.length > 0 && self.products.length > 0) {
                
                self.drafts.forEach((draft) => {

                    draft.line_items.forEach((item) => {

                        item.image = null
                        item.product = null
                        item.inventory_item_id = null
                        item.product_inventory_location = null
                        item.barcode = null

                        var product = self.products.find((item_product) => {
                            return item_product.id === item.product_id
                        })

                        if (!isUndefined(product)) {
                            item.image = product.image
                            item.product = product

                            var variant = product.variants.find((v) => {
                                return v.sku === item.sku
                            })

                            item.inventory_item_id = variant.inventory_item_id
                            item.barcode = variant.barcode || '0'

                            if (self.shipment_settings) {
                                item.product_inventory_location = self.shipment_settings.inventory_location.id 
                            }

                        }
                    })

                    drafts.push(draft)
                })

                return drafts
            } else {
                return []
            }
        },
        calculatedPackageWeight: function () {
            var self = this
            var weight = 0

            if (self.packed.length === 0) {
                return weight + self.shipment_box.weight
            } else {
                self.packed.forEach((item) => {
                    weight = weight + (item.grams * item.quantity)
                })

                return +((weight * 0.0352739619) + self.shipment_box.weight).toFixed(2) // grams to ounces
            }
        },
        isReadyToBeCompleted: function () {
            var self = this

            if (self.packed.length === 0) {
                return false
            } else {
                var isReady = true

                self.shipment.line_items.forEach((item) => {
                    if (item.quantity !== 0) {
                        isReady = false
                    }
                })
                if (self.shipment.draft_shipment_shipping_label === undefined) isReady = false
                if (self.shipment.draft_return_shipping_label === undefined) isReady = false

                return isReady
            }
        },
        canBeReprinted: function () {
            var self = this
            
            var isReady = false
            
            try {
                if (Object.keys(self.shipment.draft_shipment_shipping_label).length > 0) {
                    isReady = true
                }
            }
            catch (e) {
                console.error(e)
            }

            try {
                if (self.shipment.draft_packing_slip.length > 0) {
                    isReady = true
                }
            }
            catch (e) {
                console.error(e)
            }
            return isReady
        }
    },
    methods: {
        getProductImage: function (product_id) {
            var self = this
            var product = self.products.find((p) => {
                return p.id === product_id
            })
            if(product.image !== 'undefined') {
                return product.image
            } else {
                return null
            }
        },
        getVariantInventory: function (product, sku) {
            var variant = product.variants.find((v) => {
                return v.sku === sku
            })

            if (!isUndefined(variant)) {
                return variant.inventory_quantity
            } else {
                return 0
            }
        },
        showDraftShipment: function (draft) {
            var self = this
            self.shipment = null
            self.packed = []

            self.shipment = JSON.parse(JSON.stringify(draft))
            self.ui.shipment = true
        },
        generateTrackingLabels: function () {
            var self = this
            return new Promise((resolve, reject) => {                
                var shipment = clone(self.shipment, true)
                shipment.line_items = clone(self.packed, true)
                
                // let's make sure our shipping address does not have any null fields or it screws up shipengine
                Object.keys(shipment.shipping_address).forEach((key) => {
                    if (shipment.shipping_address[key] === null) shipment.shipping_address[key] = ''
                })

                var generateTrackingLabels = functions.httpsCallable('generateTrackingLabels')
                generateTrackingLabels({draft: shipment, shipment_location: self.shipment_settings.inventory_location, shipment_box: self.shipment_box})
                .then((tracking_numbers) => {
                    self.shipment.tracking_numbers = tracking_numbers
                    self.shipment.draft_shipment_shipping_label = {
                        label_download: {
                            href: tracking_numbers.shipment_label
                        }
                    }
                    self.shipment.draft_return_shipping_label = {
                        label_download: {
                            href: tracking_numbers.return_label
                        }
                    }
                    resolve(tracking_numbers)
                })
                .catch((err) => {
                    console.error(err)
                    reject()
                })  
            })
        },
        generatePackingSlip: function () {
            var self = this
            return new Promise((resolve, reject) => {
                var shipment = clone(self.shipment, true)
                shipment.line_items = clone(self.packed, true)

                var slip = {
                    id: shipment.id.toString(),
                    email: shipment.email,
                    subscription_id: shipment.subscription_id,
                    shipping_address: shipment.shipping_address
                }

                let line_items = []
                shipment.line_items.forEach((item) => {
                    line_items.push({
                        price: item.price,
                        quantity: item.quantity,
                        title: item.title,
                        barcode: item.barcode
                    })
                })
                slip.line_items = line_items

                var generatePackingSlip = functions.httpsCallable('generatePackingSlip')
                generatePackingSlip({draft_id: shipment.id.toString(), packing_slip: encodeURIComponent(JSON.stringify(slip))})
                .then((packing_slip_url) => {
                    self.shipment.packing_slip
                    console.log(packing_slip_url)
                    resolve(packing_slip_url)
                })
                .catch((err) => {
                    console.error(err)
                    reject()
                })  
            })
        },
        printPackingSlipAndLabels: function () {
            var self = this

            console.log('printing slip and labels')
            
            self.ui.printing = true
            Promise.all([self.generateTrackingLabels(), self.generatePackingSlip()])
            .then((results) => {
                var labels = results[0]
                var slip = results[1]

                console.log(labels, slip)
                return self.printJob({draft_id: null, print_labels: true, print_packing_slip: true})
            })
            .then(() => self.ui.printing = false)
            .catch((err) => {
                console.error(err)
                self.ui.printing = false
            })
        },
        printLabels: function () {
            var self = this
            console.log('printing labels')
            self.ui.printing = true
            /*
            self.generateTrackingLabels()
            .then((tracking_labels) => {
                self.shipment['draft_shipment_shipping_label'] = { label_download: tracking_labels.data.tracking_numbers.shipment_label }
                self.shipment['draft_return_shipping_label'] = { label_download: tracking_labels.data.tracking_numbers.return_shipment_label }
                console.log(tracking_labels)
                return self.printJob({draft_id: null, print_labels: true, print_packing_slip: false})
            })
            .then(() => self.ui.printing = false)
            .catch((err) => {
                console.error(err)
                self.ui.printing = false
            })
            */
            self.printJob({draft_id: null, print_labels: true, print_packing_slip: false})
            .then((job) => {
                console.log(job)
                self.ui.printing = false
            })
            .catch((e) => console.error(e))
        },
        printPackingSlip: function () {
            var self = this
            console.log('printing slip')

            self.ui.printing = true
            self.generatePackingSlip()
            .then((packing_slip) => {
                self.shipment.draft_packing_slip = packing_slip.data.packing_slip
                console.log(packing_slip)
                return self.printJob({draft_id: null, print_labels: false, print_packing_slip: true})
            })
            .then((print_job) => {
                console.log(print_job)
                self.ui.printing = false
            })
            .catch((err) => {
                console.error(err)
                self.ui.printing = false
            })
        },
        printJob: function (job) {
            var self = this
            var shipment = clone(self.shipment, true)

            self.ui.print_error = false

            job.draft_id = shipment.id.toString()

            return new Promise((resolve, reject) => {
                var printJob = functions.httpsCallable('printJob')
                printJob(job)
                .then((print_job) => {
                    console.log(print_job)
                    resolve(print_job)
                })
                .catch((err) => {
                    self.ui.print_error = true
                    console.error(err)
                    reject()
                })
            })
        },
        reprint: function () {
            const self = this
            var shipment = clone(self.shipment, true)

            self.ui.print_error = false

            var job = {
                draft_id: shipment.id.toString(),
                print_labels: false,
                print_packing_slip: false
            }
            
            try {
                if (Object.keys(shipment.draft_shipment_shipping_label).length > 0) {
                    job.print_labels = true
                }
            }
            catch (e) {
                console.error(e)
            }

            try {
                if (shipment.draft_packing_slip.length > 0) {
                    job.print_packing_slip = true
                }
            }
            catch (e) {
                console.error(e)
            }

            if (job.print_labels || job.print_packing_slip) {
                self.ui.printing = true
                console.log('Reprinting shipment:', shipment)
                var printJob = functions.httpsCallable('printJob')
                printJob(job)
                .then((print_job) => {
                    console.log(print_job)
                    self.ui.printing = false
                })
                .catch((err) => {
                    self.ui.print_error = true
                    console.error(err)
                    self.ui.printing = false
                })
            }
        },
        addToPacked: function (item) {
            var self = this

            if (item.quantity > 0) {

                item.quantity = item.quantity - 1

                item = JSON.parse(JSON.stringify(item))
                
                if (self.packed.length === 0) {
                    item.quantity = 1
                    self.packed.push(item)
                } else {
                    var packed_item_index = self.packed.findIndex((i) => {
                        return i.sku === item.sku
                    })

                    if (packed_item_index !== -1) {
                        self.packed[packed_item_index].quantity++
                    } else {
                        item.quantity = 1
                        self.packed.push(item)
                    }
                }
            }
        },
        removeFromPacked: function (item) {
            var self = this

            var packed_item_index = self.packed.findIndex((i) => {
                return i.sku === item.sku
            })
            var draft_item_index = self.shipment.line_items.findIndex((i) => {
                return i.sku === item.sku
            })

            if (item.quantity === 1) {
                self.packed.splice(packed_item_index, 1)
            } else {
                self.packed[packed_item_index].quantity--
            }

            self.shipment.line_items[draft_item_index].quantity++
        },
        completeShipment: function () {
            var self = this

            self.ui.loading = true
            self.ui.completing = true

            var shipment = clone(self.shipment, true)
            shipment.line_items = clone(self.packed, true)
            shipment.tracking_numbers = {
                shipment_tracking_number: shipment.draft_shipment_shipping_label.tracking_number,
                return_shipment_tracking_number: shipment.draft_return_shipping_label.tracking_number
            }

            var processShipment = functions.httpsCallable('processShipment')
            processShipment({draft_id: shipment.id.toString(), draft: shipment})
            .then((processed_shipment) => {
                console.log(processed_shipment)
                self.ui.loading = false
                self.ui.completing = false
                self.ui.shipment = false
            })
            .catch((err) => {
                console.error(err)
                self.ui.loading = false
                self.ui.completing = false
                self.ui.shipment = false
            })
        }
    },
    created () {
        var self = this
        db.collection('drafts').where('is_shipped', '==', false).onSnapshot(draftsSnapshot => {
            var drafts = []
            draftsSnapshot.forEach(function(doc) {
                drafts.push(doc.data())
            })
            self.drafts = drafts
            self.ui.loading = false
        })
        db.collection('products').onSnapshot(productSnapshot => {
            var products = []
            productSnapshot.forEach(function(doc) {
                products.push(doc.data())
            })
            self.products = products
        })
        db.collection('settings').doc('shipments').onSnapshot(shipmentSettingsSnapshot => {
            self.shipment_settings = shipmentSettingsSnapshot.data()

            self.shipment_settings.shipment_boxes.forEach((box) => {
                if (box.default) {
                    self.shipment_box = box
                }
                return
            })
        })
    },
    mounted () {

    }
}
</script>
<style lang="stylus" scoped>
#draft-shipment
    font-family 'Open Sans'!important
.v-datatable thead tr:first-child
    border-bottom none!important
.theme--dark-old .v-card
  background #40525B!important
.shipment
    cursor pointer
    transition: all 0.25s ease-in-out
.shipment:hover
    opacity 0.5
.packed
    opacity 0.25
.v-input .v-text-field .v-text-field__suffix
    font-size 10px!important
    opacity 0.5
.pointer
    cursor pointer
</style>